// FilterByViewChangeDto.js

class FilterByViewChangeDto {
    actionType = String();
    actionDetail = String();
    searchCondition = String();
    viewName = String();
    viewKeyword = String();
    viewKeywordCondition = String();
    viewSearchTarget = String();
    viewDateType = String();
    viewDateFrom = String();
    viewDateTo = String();
    viewDateTerm = String();
    viewDateUnit = String();
    viewOrTag = String();
    viewExceptTag = String();
    viewTag = String();
    viewSort = String();
    actionDate = String();
    sessionId = String();
    destinationOrgId = String();
    destinationOrgDomain = String();
    destinationOrgName = String();
    destinationPrjId = String();
    destinationPrjName = String();
    orgActionId = String();
    orgActionDomain = String();
    orgActionName = String();
    prjActionId = String();
    prjActionName = String();
    userActionId = String();
    userActionEmail = String();
    userActionName = String();
    contentTypes = String();
    hitNumber = String();
    operationScreen = String();
    viewId = String()

    constructor(data) {
        this.actionType = data.actionType;
        this.actionDetail = data.actionDetail;
        this.searchCondition = data.searchCondition;
        this.viewName = data.viewName;
        this.viewKeyword = data.viewKeyword;
        this.viewKeywordCondition = data.viewKeywordCondition;
        this.viewSearchTarget = data.viewSearchTarget;
        this.viewDateType = data.viewDateType;
        this.viewDateFrom = data.viewDateFrom;
        this.viewDateTo = data.viewDateTo;
        this.viewDateTerm = data.viewDateTerm || null;
        this.viewDateUnit = data.viewDateUnit;
        this.viewOrTag = data.viewOrTag;
        this.viewExceptTag = data.viewExceptTag;
        this.viewTag = data.viewTag;
        this.viewSort = data.viewSort;
        this.actionDate = data.actionDate;
        this.sessionId = data.sessionId;
        this.destinationOrgId = data.destinationOrgId;
        this.destinationOrgDomain = data.destinationOrgDomain;
        this.destinationOrgName = data.destinationOrgName;
        this.destinationPrjId = data.destinationPrjId;
        this.destinationPrjName = data.destinationPrjName;
        this.orgActionId = data.orgActionId;
        this.orgActionDomain = data.orgActionDomain;
        this.orgActionName = data.orgActionName;
        this.prjActionId = data.prjActionId;
        this.prjActionName = data.prjActionName;
        this.userActionId = data.userActionId;
        this.userActionEmail = data.userActionEmail;
        this.userActionName = data.userActionName;
        this.contentTypes = data.contentTypes;
        this.hitNumber = data.hitNumber;
        this.operationScreen = data.operationScreen;
        this.viewId = data.viewId
    }
}

export default FilterByViewChangeDto;
